import axios from "axios";

export const uploadImage = async (file) => {
  if (!file) {
    throw new Error("No file provided");
  }

  const formData = new FormData();
  formData.append("file", file);
  formData.append("upload_preset", process.env.REACT_APP_UPLOAD_PRESET);

  try {
      const res = await axios.post(
        `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUD_NAME}/raw/upload`,
        formData
      );

    return res.data.secure_url;
  } catch (err) {
    console.error("Cloudinary error:", err.response?.data || err.message);
    throw err;
  }
};
